export const USER_PASSWORD_IS_INITIAL = -2

export const authTypeMap = [
  {
    label: '按钮',
    value: 'button',
    color: 'green'
  },
  {
    label: '菜单',
    value: 'menu',
    color: 'gold'
  },
  {
    label: '页面',
    value: 'page',
    color: 'blue'
  }
]

export const accountTypeMap = {
  1: '微信',
  2: '支付宝',
  4: '民生银行',
  5: '招商银行',
  7: '威富通',
  8: '光大银行',
}

export const FieldTypeMap = {
  input: '2',
  textarea: '3',
  select: '4',
  dateRangePicker: '5',
  table: '7',
  number: '8',
  treeData: '9',
  cascader: '12',
  phone: '13',
  mail: '14',
}

export const positionFieldTypeMap = {
  input: '1',
  select: '2',
  textarea: '3',
  dateRangePicker: '4',
  cascader: '5',
}


export const RuleLogicMap = {
  include: 1,
  exclude: 2,
  equal: 3,
  greaterThan: 4,
  lessThan: 5,
  isEmpty: 6,
  isNotEmpty: 7
}

export const RelationTypeMap = {
  and: 1,
  or: 2,
  not: 3
}

export const sampleTableMap = {
  apply: {
    label: '报名表',
    key: 'applyForm',
    fieldKey: 'applyFormFields'
  },
  examinationRoom: {
    label: '笔试准考证',
    key: 'examCertificate',
    fieldKey: 'examCertificateFields'
  },
  interviewNotice: {
    label: '面试准考证',
    key: 'interviewNotice',
    fieldKey: 'interviewNoticeFields'
  }
}

export const examApplyCostMap = {
  uniformCharge: {
    label: '统一收费',
    value: 1
  },
  chargeBySubject: {
    label: '按科目收费',
    value: 2
  }
}

export const createExamMonitorMap = {
  applyShouldKnow: {
    label: '考试文件',
    tabsKey: 'examFile'
  },
  timeConfig: {
    label: '时间安排',
    tabsKey: 'timeConfig'
  },
  applySiteConfig: {
    label: '报名点',
    tabsKey: 'applySite'
  },
  examFieldConfig: {
    label: '报名字段',
    tabsKey: 'applyField'
  },
  subjectConfig: {
    label: '考试科目',
    tabsKey: 'subjectConfig'
  },
  levelConfig: {
    label: '考试分类',
    tabsKey: 'classification'
  },
  positionTemplateConfig: {
    label: '职位字段',
    tabsKey: 'positionField'
  },
  positionConfig: {
    label: '职位管理',
    tabsKey: 'position'
  },
  applyForm: {
    label: '样表设置',
    tabsKey: 'sampleFile'
  }
}

export const examinationAllocationMonitorMap = {
  check: {
    label: '资格审核'
  },
  room: {
    label: '考场安排'
  },
  template: {
    label: '准考证模板'
  }
}

export const examinationInterviewMonitorMap = {
  template: {
    label: '准考证模板'
  },
  imp: {
    label: '面试数据导入'
  }
}

export const examinationStatusMap = {
  0: '创建考试',
  1: '报名中',
  2: '考场安排',
  3: '成绩发布',
  4: '面试通知',
  5: '考试结束'
}

export const payStatusMap = {
  '-1': {
    label: '申请退款成功',
    className: 'text-primary'
  },
  0: {
    label: '未缴费',
    className: 'text-danger'
  },
  1: {
    label: '已缴费',
    className: 'text-success'
  },
  2: {
    label: '不需要缴费',
    className: 'text-primary'
  },
  3: {
    label: '贫困生免费',
    className: 'text-warning'
  }
}

export const takeExamCheckMap = {
  0: {
    label: '未确认',
    className: 'text-danger'
  },
  1: {
    label: '已确认',
    className: 'text-success'
  }
}

export const examCheckStatus = {
  '-1': {
    label: '审核不通过',
    className: 'text-danger'
  },
  0: {
    label: '未提交',
    className: 'text-danger'
  },
  1: {
    label: '待审核',
    className: 'text-primary'
  },
  2: {
    label: '审核通过',
    className: 'text-success'
  }
}

export const reviewStageOptions = [
  { label: '全部', value: '' },
  { label: '初审', value: 1 },
  { label: '复审', value: 2 }
]

export const reviewStageMap = {
  1: { label: '初审', color: 'green' },
  2: { label: '复审', color: 'blue' }
}

export const isExamRecheckEnabled = (exam) => exam?.recheck === 1

/** 初审可审核角色 */
export const FIRST_REVIEW_CHECK_ROLE_TAGS = ['checker', 'superAdmin', 'operator', 'organization', 'applySiteCharger']

/** 复审可审核角色 */
export const SECOND_REVIEW_CHECK_ROLE_TAGS = ['applyRechecker', 'superAdmin', 'operator', 'organization', 'applySiteCharger']

/** 管理端可审核的管理角色 */
export const EXAM_CHECK_ADMIN_ROLE_TAGS = ['superAdmin', 'operator', 'organization', 'applySiteCharger']

/**
 * 根据当前账号角色与考生审核阶段，判断是否有权审核该考生
 * @param {string} roleTag 当前角色
 * @param {number|string} reviewStage 考生审核阶段：1 初审，2 复审
 * @param {object} exam 当前考试
 */
export const canRoleCheckExamineeByReviewStage = (roleTag, reviewStage, exam) => {
  if (!roleTag) {
    return false
  }

  const stage = Number(reviewStage)

  if (!isExamRecheckEnabled(exam)) {
    return FIRST_REVIEW_CHECK_ROLE_TAGS.includes(roleTag)
  }

  if (stage === 1) {
    return FIRST_REVIEW_CHECK_ROLE_TAGS.includes(roleTag)
  }

  if (stage === 2) {
    return SECOND_REVIEW_CHECK_ROLE_TAGS.includes(roleTag)
  }

  return EXAM_CHECK_ADMIN_ROLE_TAGS.includes(roleTag)
}

export const examBatchMap = {
  1: '标准考场',
  2: '非标准考场'
}

export const examProcessTabsMap = {
  apply: ['examDashboard', 'applySite', 'examFile', 'timeConfig', 'subjectConfig', 'classification', 'examApplyCost', 'applyField', 'positionField', 'position', 'sampleFile', 'applyPublicity', 'baseConfigurationSetting'],
  examinationRoom: ['examFile', 'timeConfig', 'sampleFile', 'baseConfigurationSetting'],
  publicResult: ['examFile', 'timeConfig', 'baseConfigurationSetting'],
  interviewNotice: ['examFile', 'timeConfig', 'sampleFile', 'baseConfigurationSetting'],
}
